import {
  Dialog,
  DialogContent,
  DialogTitle,
} from '@/components/ui/dialog';

import {
  CrashingOutRunDetailsPanel,
  type CrashingOutRunDetailsPanelProps,
} from './CrashingOutRunDetailsPanel';

interface CrashingOutRunDetailsModalProps
  extends Omit<CrashingOutRunDetailsPanelProps, 'enabled' | 'variant'> {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export const CrashingOutRunDetailsModal = ({
  open,
  onOpenChange,
  ...panelProps
}: CrashingOutRunDetailsModalProps) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="flex h-[92vh] min-h-0 max-w-[96vw] flex-col p-0 overflow-hidden sm:max-w-6xl">
        <DialogTitle className="sr-only">Agent Run Details</DialogTitle>
        <CrashingOutRunDetailsPanel
          {...panelProps}
          enabled={open}
          variant="modal"
        />
      </DialogContent>
    </Dialog>
  );
};
